import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  vehicleExplanation: () =>
    i18n.t(i18nKeys.backgroundCheck__vehicleExplanation),
  vehicleTypeLabel: () => i18n.t(i18nKeys.backgroundCheck__vehicleTypeLabel),
  required: () => i18n.t(i18nKeys.common__required),
  birthdate: () => i18n.t(i18nKeys.common__birthdate),
  continue: () => i18n.t(i18nKeys.common__continue),
  title: () => i18n.t(i18nKeys.backgroundCheck__australiaPageTitle),
  jpnCitizenshipTitle: () => i18n.t(i18nKeys.backgroundCheck__jpnCitizenshipTitle),
  jpnCitizenshipParagraph: () => i18n.t(i18nKeys.backgroundCheck__jpnCitizenshipExplanation),
  yes: () => i18n.t(i18nKeys.common__yes),
  no: () => i18n.t(i18nKeys.common__no),
}
